var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup453(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(-1741 -485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(1741 485)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M169.415,5.328c.436.426.791.785,1.16,1.13.179.166.171.292,0,.457-.4.386-.793.78-1.18,1.179-.156.161-.283.2-.461.022q-1.881-1.894-3.774-3.777a.26.26,0,0,1,0-.435q1.906-1.9,3.8-3.8a.221.221,0,0,1,.372,0c.415.424.832.846,1.26,1.257.172.165.134.285-.018.429-.374.356-.741.718-1.122,1.088a.566.566,0,0,0,.441.087q3.356.005,6.711,0a5.627,5.627,0,0,1,5.637,4.968c.014.11.006.223.017.333.026.265-.077.385-.356.379-.531-.012-1.063-.011-1.594,0-.26.005-.371-.087-.395-.359a3.212,3.212,0,0,0-3.205-2.982c-2.324-.02-4.647-.007-6.971-.007-.071,0-.142.012-.327.029",
    transform: "translate(1587.345 490.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(1756.771 499.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M243.1,269.931c-1.116,0-2.232-.006-3.348,0-.234,0-.311-.074-.3-.3.016-.354.017-.711,0-1.065-.012-.241.083-.306.308-.3.355.014.711-.007,1.065.008.206.008.263-.07.258-.266-.011-.439,0-.879-.006-1.319,0-.188.067-.252.252-.248.711.014.585-.079.6.585q.009.507,0,1.015c0,.155.04.233.213.231q.989-.01,1.979,0c.174,0,.215-.076.213-.231-.006-.448,0-.9,0-1.344,0-.181.052-.259.245-.256.719.014.592-.078.6.578.006.33.01.66,0,.989-.007.2.053.274.258.265.355-.014.71.007,1.065-.008.225-.009.32.056.308.3-.018.354-.016.711,0,1.065.01.231-.067.307-.3.3-1.133-.01-2.266,0-3.4,0",
    transform: "translate(-239.448 -261.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M252.305,330.561c0,.329,0,.658,0,.987,0,.156-.047.232-.216.23-.766-.01-.619.084-.63-.6-.009-.531.005-1.063,0-1.594,0-.2.052-.289.269-.283.684.018.569-.076.58.575,0,.228,0,.455,0,.683",
    transform: "translate(-250.689 -320.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M324.172,330.558c0,.337,0,.675,0,1.012,0,.161-.057.227-.221.225-.759-.011-.614.085-.625-.6-.008-.54,0-1.08,0-1.62,0-.184.06-.255.248-.251.715.014.588-.078.6.579,0,.219,0,.439,0,.658Z",
    transform: "translate(-317.685 -320.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M248.75,201.691c-.677,0-1.353,0-2.03,0a1.194,1.194,0,0,1-1.224-1.213q0-.837,0-1.674a1.193,1.193,0,0,1,1.206-1.2q2.055,0,4.11,0a1.191,1.191,0,0,1,1.211,1.2q.006.85,0,1.7a1.192,1.192,0,0,1-1.193,1.192c-.693,0-1.387,0-2.08,0",
    transform: "translate(-245.041 -197.596)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M12.844,294.741a.833.833,0,0,0-.5-.085c-2.249,0-4.5,0-6.748,0a5.638,5.638,0,0,1-5.584-4.987C0,289.544.009,289.419,0,289.3c-.013-.215.077-.321.3-.32.568,0,1.137.005,1.706,0,.241,0,.313.116.336.339a3.265,3.265,0,0,0,2.6,2.952,3.116,3.116,0,0,0,.7.052q3.43.006,6.86,0c.073,0,.146-.007.329-.017-.345-.345-.635-.632-.92-.923-.485-.5-.512-.377,0-.9.313-.316.635-.624.941-.946.167-.175.3-.213.489-.021q1.866,1.883,3.748,3.75c.17.169.163.3-.006.462q-1.881,1.869-3.748,3.75c-.17.171-.287.176-.454,0-.375-.394-.757-.782-1.155-1.152-.211-.2-.229-.34-.007-.537.368-.327.72-.673,1.119-1.049",
    transform: "translate(1752.388 221.908)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup453);
export default __webpack_public_path__ + "static/media/Group453.0f416ee020ab233932b805a613fec710.svg";
export { ForwardRef as ReactComponent };